<template>
  <div>
    时间范围：
    <el-date-picker
      v-model="timeRange"
      type="datetimerange"
      :picker-options="pickerOptions"
      range-separator="至"
      start-placeholder="开始时间"
      end-placeholder="结束时间"
      align="right"
      value-format="yyyy-MM-dd HH:mm:ss"
    >
    </el-date-picker>
    <el-row style="margin-top: 10px">
      <el-upload
        :show-file-list="false"
        accept=".zip,.txt,.log"
        :on-success="handleSuccess" :on-error="handleError"
        :action="baseUrl3+'management3/analysis/terminalLog'"
        :data="{
        startTime:timeRange[0],
        endTime:timeRange[1]
        }"
        :headers="{
              Authorization: 'Bearer ' + token
            }"
      >
        <el-button type="primary" v-if="listOperations.some(func => func.name.includes('download'))">上传压缩包</el-button>
      </el-upload>
    </el-row>
    <el-tabs v-model="tabActive" @tab-click="handleClick">
      <el-tab-pane label="地址" name="address">
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item v-for="(item,index) in addrData" :name="index">
        <span slot="title" class="collapse-title">
          {{item.ModulesName}}
        </span>
            <el-table :data="item.Data" style="width: 100%">
              <el-table-column prop="addr" label="地址"></el-table-column>
              <el-table-column prop="filePath" label="位置"></el-table-column>
              <el-table-column prop="date" label="时间"></el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
      <el-tab-pane label="请求" name="param">
        <el-collapse v-model="activeNames" @change="handleChange">
          <el-collapse-item v-for="(item,index) in requestData" :name="index">
        <span slot="title" class="collapse-title">
          {{item.ModulesName}}
        </span>
            <el-table :data="item.Data" style="width: 100%">
              <el-table-column prop="requestUrl" label="地址"></el-table-column>
              <el-table-column prop="requestParams" label="请求参数">
                <template v-slot="{row}">
                  <el-popover
                    placement="bottom"
                    width="300"
                    data-html="true"
                    trigger="click"
                  >
                    <pre style="overflow-x: auto;">
                        {{ JSON.parse(row.requestParams) }}
                    </pre>
                    <el-button slot="reference">点击查看请求参数</el-button>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="requestDate" label="请求时间"></el-table-column>
              <el-table-column prop="responseData" label="响应参数">
                <template v-slot="{row}">
                  <el-popover
                    placement="bottom"
                    width="300"
                    data-html="true"
                    trigger="click">
                      <pre style="overflow-x: auto;">
                        {{ JSON.parse(row.responseData) }}
                    </pre>
                    <el-button slot="reference">点击查看响应参数</el-button>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column prop="responseDate" label="响应时间"></el-table-column>
              <el-table-column prop="filePath" label="位置"></el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </el-tab-pane>
    </el-tabs>


  </div>
</template>

<script>
  import JsonViewer from 'vue-json-viewer'
  import {mapMutations, mapState} from "vuex";

  export default {
    components: {
      JsonViewer
    },
    name: "AddressLogs",
    data() {
      return {
        timeRange: ['', ''],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end])
            }
          }]
        },
        showFileList: true,
        activeNames: "",
        tabActive: "address",
        addrData: [],
        tableData: [],
        npsParamData: [],
        requestData: [],
        uploadFile: "",
        backList: ["NPS地址", "STP地址"],
      }
    },
    created() {
      this.getListOperations('logs/addressLogs')
      if (!this.currentMenu) {
        return
      }
    },
    computed: {
      ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
      token() {
        return localStorage.getItem('token')
      },
    },
    methods: {
      ...mapMutations(['getListOperations']),
      handleSuccess({code, msg, data}, file, fileList) {
        if (code == 20000) {
          this.$message.success("上传成功");
          this.addrData = data.addr;
          this.requestData = data.request;
        } else {
          this.$message.error("上传失败！原因：" + msg);
        }
      },
      handleError(err, file, fileList) {
        this.$message({showClose: true, message: "上传失败", type: "error"});
        console.log("error=" + err);
      },
      handleChange() {

      },
      handleClick() {

      },
      getList() {
        let model = {
          uploadFile: this.uploadFile,
          startTime: this.timeRange[0],
          endTime: this.timeRange[1],
        };
        this.$axios
          .post(
            this.baseUrl3 +
            "management3/analysis/terminalLog", model
          )
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {

            } else {
              this.$message({showClose: true, message: msg, type: "error"});
              console.log(msg);
            }
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: "系统异常，查询失败",
              type: "error"
            });
            console.log(error);
          });
      },
    }

  }
</script>

<style scoped>
  .collapse-title {
    flex: 1 1 auto;
    order: 1;
  }

  /*/deep/ pre {*/
  /*  white-space: pre-wrap !important; !*css-3*!*/
  /*  white-space: -moz-pre-wrap; !*Mozilla,since1999*!*/
  /*  white-space: -pre-wrap; !*Opera4-6*!*/
  /*  white-space: -o-pre-wrap; !*Opera7*!*/
  /*  word-wrap: break-word; !*InternetExplorer5.5+*!*/
  /*}*/
</style>
